import { router } from "@inertiajs/react";
import { DetailTemplate } from "@/templates/DetailTemplate";
import { StoryCard } from "@/feed/StoryCard";
import { type StoryPost, type Comment, timeAgo } from "@/lib/feedApi";

interface Props {
  post: StoryPost;
  comments: Comment[];
}

export default function FeedShow({ post, comments }: Props) {
  return (
    <DetailTemplate
      title={post.displayTitle}
      subtitle={
        post.projectName
          ? `${post.projectName} · ${timeAgo(post.createdAt)}`
          : timeAgo(post.createdAt)
      }
      backTo="/feed"
      backLabel="Back to feed"
      breadcrumbs={[
        { label: "Home", to: "/" },
        { label: "Feed", to: "/feed" },
        { label: post.displayTitle },
      ]}
    >
      <div className="mx-auto max-w-2xl">
        <StoryCard post={post} full initialComments={comments} onDeleted={() => router.visit("/feed")} />
      </div>
    </DetailTemplate>
  );
}
